import { BonanzaLogo, Box, Image, Text } from '@bonanza-social/moonlight';
import React, { memo } from 'react';

function IntroHeader() {
  return (
    <>
      <Box centerContent marginBottom="space-200">
        <BonanzaLogo />
      </Box>
      <Box flexDirection="row" alignItems="center">
        <Image
          name="auth.IntroLeafs"
          width={40}
          height={40}
          objectFit="contain"
        />
        <Box flex={1} paddingHorizontal="space-200" paddingTop="space-200">
          <Text
            variant="h5"
            locNS="auth"
            locKey="introScreenOfficialLabel"
            gradient="darkSurfaceAccent"
            textAlign="center"
          ></Text>
          <Text
            variant="h5"
            locNS="auth"
            locKey="introScreenCasinoLabel"
            gradient="darkSurfaceAccent"
            textAlign="center"
          ></Text>
        </Box>
        <Image
          name="auth.IntroRaptors"
          objectFit="contain"
          width={40}
          height={40}
        />
      </Box>
    </>
  );
}

export default memo(IntroHeader);
